/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cardType[_ngcontent-%COMP%]{display:inline}.defaultStarIconImage[_ngcontent-%COMP%]{width:2rem}.expRed[_ngcontent-%COMP%]{color:red;font-weight:700}.inline[_ngcontent-%COMP%]{display:flex}.inline[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-right:6px}.noMethods[_ngcontent-%COMP%]{margin-top:1rem;text-align:center}\n/*# sourceMappingURL=manage-payments.component.css.map*/"];
export { styles as styles };
